import React, { ReactNode } from 'react';
import { toast } from 'react-toastify';
import './index.scss';

interface NotificationErrorProps {
  content?: string | ReactNode;
}
const NotificationError: React.FC<NotificationErrorProps> = ({ content }) => {
  const handleShowNotiError = (content: ReactNode | string) => {
    return toast(<div className="d-flex align-items-center gap-10">{content}</div>, {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
      className: 'toast__notification-error',
    });
  };

  return <div>{handleShowNotiError(content)}</div>;
};

export default NotificationError;
